<template>
  <div>
    DataDog Test

    {{content}}

  </div>
</template>

<script setup>

import {customClientErrorHandler, customServerErrorHandler} from "~/services-optimized/customErrorService";
import {ajax} from "~/services-optimized/ajaxService";


//-----SERVER SIDE REQUEST
let productId = 1;
const {data: content, error, pending} = await useAsyncData(
    'content',
    async () => {
      return await ajax("https://fakestoreapi.com/products/" + productId)
    },
    {
      //maxAge: 1000 * 60 * 60, // cache for 1 hour
      lazy: true
    }
)
//-----END OF SERVER SIDE REQUEST


onMounted(async () => {

  let productClientId = 1;
  //-----CLIENT SIDE REQUEST
  try {
    const data = await ajax(
        'https://fakestoreapi.com/products/'+productClientId
    );
    console.log('getItem client side--->', data);

  }catch (e){
    let errorData = {productId: productClientId}
    customClientErrorHandler(
        e,
        'high',
        'Client Side Error - trying to fetch product',
        errorData
    );
  }
  //-----END OF CLIENT SIDE REQUEST

});

definePageMeta({
  layout: false
})
</script>